<template>
  <dashboard-page :image-header-props="imageHeaderProps">
    <template v-slot:dashboard>
      <div class="margin-ml">
        <template>
          <property class="margin-bottom-m" :name="'סוג מינוי'" :value="'תקופת ניסיון'"/>
          <property class="margin-bottom-m" :name="'סיום תקופת הניסיון'" :value="trialEndDateFormatted"/>
          <div v-if="benefitId">
            <benefit-notification-box-v2
              :flavor="shouldPromoteWebPayment ? flavors.webOnly : flavors.accountSettings"
              @link-click="onBenefitBoxLinkClick"
            />
          </div>
          <div v-if="shouldPromoteWebPayment && !benefitId">
            <web-payment-notification-box @link-click="openPayOnWebPopup" />
          </div>
        </template>
      </div>

      <template v-if="!shouldPromoteWebPayment">
        <separator/>
        <div class="margin-ml">
          <riseup-button :action="subscribeClicked" :size="'slim'" :title="subscribeButtonTitle" />
        </div>
      </template>
    </template>
  </dashboard-page>
</template>

<script>
import AccountSettingsMixin from '@/pages/responsive-pages/authenticated/navigation-pages/account-settings/AccountSettingsMixin.vue';
import BenefitMixin from '@/pages/responsive-pages/authenticated/subscription/V2/BenefitMixin.vue';
import BenefitNotificationBoxV2 from '@/pages/responsive-pages/authenticated/subscription/V2/BenefitNotificationBox2.vue';
import WebPaymentNotificationBox from '@/pages/responsive-pages/authenticated/subscription/V2/WebPaymentNotificationBox.vue';
import { isIosNativeApp } from '@/utils/deviceUtils';
import BaseUI from '@riseupil/base-ui';
import { mapActions, mapState } from 'vuex';
import dates from '../../../../../utils/dates';
import Property from './Property.vue';
import SubscribeClickHandler from './SubscribeClickHandler.vue';
import TrialPayOnWebPopup from './components/PayOnWebPopups/TrialPayOnWebPopup.vue';
import PayOnWebPromoPopup from './components/PayOnWebPopups/PayOnWebPromoPopup.vue';

export default {
  name: 'TrialSettings',
  components: {
    BenefitNotificationBoxV2,
    WebPaymentNotificationBox,
    Property,
    RiseupButton: BaseUI.RiseupButton,
    Separator: BaseUI.Separator,
    DashboardPage: BaseUI.Pages.DashboardPage,
  },
  mixins: [SubscribeClickHandler, BenefitMixin, AccountSettingsMixin],
  computed: {
    ...mapState('benefits', ['benefitId']),
    subscribeButtonTitle() {
      return this.benefitId ? 'למימוש ההטבה' : 'לבחור סוג מינוי';
    },
    ...mapState('subscriptionState', ['until']),
    trialEndDateFormatted() {
      return dates.shortDateFormat(this.until);
    },
    shouldPromoteWebPayment() {
      return isIosNativeApp();
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal', 'closeModal']),
    openPayOnWebPopup() {
      this.openModal({
        component: TrialPayOnWebPopup,
        props: {
          onClose: () => this.closeModal(),
        },
      });
    },
    onBenefitBoxLinkClick() {
      if (this.shouldPromoteWebPayment) {
        this.openModal({
          component: PayOnWebPromoPopup,
          props: {
            onClose: () => this.closeModal(),
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
